<template>
  <div id="announcement_list">
    <!--
    <div class="d-flex justify-content-center" v-if="listLoading">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    -->
    <div class="listComps">
     
      <TableActionHeader 
        @filterChange="(val) => {this.filterString = val}"
        :selectOptions="statusOptions" 
        :selected="statusFilter" 
        @filterSelect="onFilterSelect"
        @newItem="this.onNewAnn">
      </TableActionHeader>
      <b-table hover striped :items="listData" :fields="fields"
          sticky-header="calc(100vh - 350px)"
          :responsive="false"
          :small="true"
          primary-key="tunnus"
          ref="announcementList"
          selectable
          select-mode="single"
          @row-selected="onRowSelected"
          :filter="filter"
          :filter-function="listFilterFunction"
          :per-page="pagingPerPage"
          @filtered="this.onFiltered"
          :current-page="this.currentPage"
          :busy="loading"
          class="infotext-table">
          <template v-slot:cell(status)="data">
              <!-- <b-badge pill variant="success" v-if="isValid(data.item)">&#10003;</b-badge> -->
              <InfoValidityIcon :info="data.item" scale="1.5" />
          </template>
          <template v-slot:cell(otsikko)="data">
             <span >{{ data.value }}</span>
          </template>
          <template v-slot:cell(thumbnail)="data">
            <AnnouncementImage :imageid="data.item.tunnus" :showResolution="false" :width="100" /> 
           
            <!-- <b-img-lazy :src="getImageData(data.item.tunnus)"/> -->

          </template>
          <template v-slot:cell(kelpoisuusalkaa)="data">
              <!--
              <p class="timeInTableCell"> &#8614; {{ alkuaika(data.item) }}</p>
              <p class="timeInTableCell"> &#8677; {{ loppuaika(data.item) }}</p>
              -->
              <p class="timeInTableCell"><b-icon icon="calendar-check" scale='1' variant='success'/>{{ alkuaika(data.item) }}</p>
              <p class="timeInTableCell"><b-icon icon="calendar-X" variant='danger'/>{{ loppuaika(data.item) }}</p>
          </template>
          <template #table-busy>
                <Loading />
          </template>
      </b-table>
      <TablePagination :perPage="pagingPerPage" :totalRows="listLength" @pageChange=onPageChange></TablePagination>
    </div>
  </div>
</template>

<script>
import announcements from '@/store/announcements/announcements'

import TablePagination from '@/components/Misc/TablePagination.vue'
import TableActionHeader from '@/components/Misc/TableActionHeader.vue'
import AnnouncementImage from '@/components/Announcements/AnnouncementImage'
import moment from "moment";

export default {
  name: 'ImgAnnouncementList',
  components: {
    TableActionHeader,
    TablePagination,
    AnnouncementImage
  },
  props: {
  },
  data: function() {
    return {
      fields: [ 
        { key:'status', label: this.$t('text_announcement_list.validity'), sortable: true, tdClass: 'status' },
        { key:'otsikko', label: this.$t('text_announcement_list.subject'), sortable: true },
        { key:'thumbnail', label: this.$t('text_announcement_list.image') },
        { key:"kelpoisuusalkaa", label:this.$t('text_announcement_list.validity_time'), sortable: true },
      ],
      currentPage: 1,
      pagingPerPage: 10,
      selected: [],
      listData: [],
      filterString: null,
      loading: true,
      listLength: 0,
      statusOptions: [
        { id: 'all', label: this.$t('text_announcement_list.status.all'), icon: 'list' },
        { id: 'valid', label: this.$t('text_announcement_list.status.valid'), icon: 'check-circle', variant: 'success' },
        { id: 'upcoming', label: this.$t('text_announcement_list.status.upcoming'), icon: 'check-circle', variant: 'warning'  },
        { id: 'expired', label: this.$t('text_announcement_list.status.expired'), icon: 'x-circle', variant: 'secondary' }
      ],
      statusFilter: "valid"
    }
  },
  computed: {
    storedImgAnnouncementList: function() {
      return this.$store.state.announcements.imgAnnouncementList.listData;
    },
    filter() {
      return this.statusFilter + this.filterString;
    }
  },
  beforeCreate: function() {
    if (!this.$store.state.announcements) {
      this.$store.registerModule("announcements" , announcements);
    }
  },
  mounted: function() {
    if(this.listData.length === 0) {
      this.loading = true;
      this.$store.dispatch('announcements/getImageAnnouncementList')
      .then(
         (/*data*/) => {/*this.listData = data;*/ this.loading = false;},
         () => {this.$travellerGetDataError();}
       );
    }
    this.deselectAll();
  },
  watch: {
    storedImgAnnouncementList: function() {
      this.listData = this.storedImgAnnouncementList;
    }
  },
  methods: {
    listFilterFunction: function(item) {
      this.currentPage = 1;
      
      var statusFilterOK = this.statusFilter == "all" || this.getValidity(item) == this.statusFilter;

      if(this.filterString == null || this.filterString === "") {
         return statusFilterOK;
      }

      // Tekstifiltteri
      if(statusFilterOK) {
        try {
          if(this.filterString.length < 2) {
            return false;
          }
          var matchString = ".*"+this.filterString+".*";
          var regxi = new RegExp(matchString, 'i');
          if(regxi.test(item.otsikko)) {
            return true;
          } else {
            return false;
          }
        } catch(err) {
          return true;
        }
      } else {
        return false;
      }
    },
    onFiltered: function(filteredList) {
      this.listLength = filteredList.length;
    },
    onNewAnn: function() {
      this.$emit('newItem');
    },
    onPageChange: function(page) {
      this.currentPage = page;
    },
    getSelectedItem: function() {
        return this.selected;
    },
    dateFormatter: function(dateString) {
      var aika = moment(dateString);
      return aika.format("D.M.YYYY HH:mm")
    },
    onRowSelected: function(items) {
      this.selected = items
      this.$emit('selectedItem',this.selected);
    },
    deselectAll: function() {
      this.$refs.announcementList.clearSelected();
    },
    alkuaika: function(item) {
      // vanhan rakenteen mukainen kelpoisuusalkaa
      if(item.kelpoisuusalkaa && item.kelpoisuusalkaa != null) {
        var aika = moment(item.kelpoisuusalkaa);
        if(aika.isValid()) {
          return aika.format("D.M.YYYY")
        }
      }
      if(item.ajastusList[0].id == null) {
        return "";
      }

      var aikaisin = moment("20500101", "YYYYMMDD");
      item.ajastusList.forEach((i) => {
        var aika = moment(i.validityBegins, "YYYY-MM-DD")
        if(aika.isBefore(aikaisin)) {
          aikaisin = aika;
        }
      });
      return aikaisin.format("D.M.YYYY");
    },
    loppuaika: function(item) {
      /* Käsittämätön häkki
      Tällä tavoin filtteröidyn taulun pituus saadaan katsottua ekalla kerralla. myöhemmin se määritellään
      onFiltered metodin kautta joka olis oikea tapa tehdä se. se ei vaan toimi listan latauksessa */
      try{
        if(this.listLength == 0) {
          this.listLength = this.$refs.announcementList.filteredItems.length;
        }
      }catch(Error){/*tässä pitää olla täysin turha kommentti koska muuten tää paska ei käänny...*/}


      // vanhan rakenteen mukainen
      if(item.kelpoisuusloppuu != 'undefined' && item.kelpoisuusloppuu !== null) {
        var aika = moment(item.kelpoisuusloppuu);
        if(aika.isValid()) {
          return aika.format("D.M.YYYY")
        }
      }
      if(item.ajastusList[0].id == null) {
        return "";
      }
      
      var latest = moment("19700101", "YYYYMMDD");
      item.ajastusList.forEach((i) => {
        var aika = moment(i.validityEnds, "YYYY-MM-DD")
        if(aika.isAfter(latest)) {
          latest = aika;
        }
      });


      let formattedTime = latest.format("D.M.YYYY");
      if(formattedTime == "31.12.2099")
        formattedTime =  this.$t('announcement_schedule.valid_until_further_notice');
     
      return formattedTime;

    },
    isValid: function(item) {
      var nyt = moment();
      if(item.kelpoisuusloppuu && moment(item.kelpoisuusloppuu).isValid()) {
        var loppu = moment(item.kelpoisuusloppuu);
        var alku = moment(item.kelpoisuusalkaa);
        if(alku.isBefore(nyt) && loppu.isAfter(nyt)) {
          return true;
        } else false;
      } else {
        // Uuden aikataulurakenteen mukainen tiedote
        var validi = false;
        item.ajastusList.forEach((i) => {
            var loppu = moment(i.validityEnds, "YYYY-MM-DD");
            loppu.hour(23);
            loppu.minute(59);
            var alku = moment(i.validityBegins, "YYYY-MM-DD");
            alku.hour(0);
            alku.minute(0);
            if(nyt.isBetween(alku, loppu)) {
              validi = true;
              return;
            }
        });
        return validi;
      }
    },
    onFilterSelect(id){
      this.statusFilter = id;
    },
    getValidity(info){
      var validity = "?";
      if(info && info.ajastusList){
        var now = Date.now();
        info.ajastusList.forEach( schedule => {
          var from = Date.parse(schedule.validityBegins);
          var to = Date.parse(schedule.validityEnds);
          if(from <= now && to >= now) validity = "valid";
          if(from > now && validity != "valid") validity = "upcoming";
          if(to < now && validity != "valid" && validity != "upcoming" ) validity = "expired";
        });
      }
      return validity;
    },
    /*
    getImageData(id) {
        this.$store.dispatch('announcements/getAnnouncementImage' , id )
          .then( (data) => {
            //this.imgData = data; 
            return data;
           },
             () => {}
           );
      }
    */
   async getImageData(id) {
      //return await this.$store.dispatch('announcements/getAnnouncementImage' , id )
      this.$store.dispatch('announcements/getAnnouncementImage' , id )
          .then( (data) => {
            //this.imgData = data; 
            return data;
           },
             () => {}
           );
   }



  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.timeInTableCell {
  margin-bottom: 0.1rem;
   svg {
    margin-right: 8px;
  }
}

</style>
